<script lang="ts">
  import { yPct } from '../../utils/chart';

  // Dots draws points in a chart's overlay, where they stay round however
  // the chart stretches (spec 010 FR-033). faint draws the small, pale
  // points of a measure taken once a day under its 7-day average.
  interface Dot {
    at: number;
    v: number | null | undefined;
  }
  let { dots, color, lo, hi, faint = false }: { dots: Dot[]; color: string; lo: number; hi: number; faint?: boolean } = $props();
</script>

{#each dots as d, i (i)}
  {#if d.v != null}
    <span class="absolute rounded-full pointer-events-none {faint ? 'w-1.5 h-1.5' : 'w-2 h-2'}" aria-hidden="true"
      style="left: calc({d.at * 100}% - {faint ? 3 : 4}px); top: calc({yPct(d.v, lo, hi)}% - {faint ? 3 : 4}px); background: {color};
        {faint ? 'opacity: 0.45;' : 'box-shadow: 0 0 0 2px var(--theme-card-bg);'}"></span>
  {/if}
{/each}
